
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","width":"20","height":"20","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.39 13.2"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_1-2","fill":"#2b938c","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M5.2 8.61c-.39-.62-.61-1.35-.61-2.14 0-2.27 1.84-4.1 4.11-4.1.79 0 1.52.22 2.14.61l1.41-1.41c-1.1-.38-2.3-.58-3.55-.58C4.62.99 1.06 3.16.04 6.28c-.05.12-.05.27 0 .39.52 1.58 1.69 2.92 3.25 3.85L5.2 8.61zM14.25 2.53l-1.96 1.96c.33.59.51 1.26.51 1.98 0 2.27-1.83 4.11-4.1 4.11-.73 0-1.4-.19-1.99-.51l-1.36 1.36c1.04.34 2.17.52 3.35.52 4.06 0 7.64-2.16 8.67-5.28.03-.12.03-.27 0-.39-.5-1.53-1.63-2.83-3.12-3.75z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M7 6c-.33 0-.64-.14-.86-.36-.09.26-.13.54-.13.83 0 .39.08.77.23 1.1L9.8 4.01a2.71 2.71 0 00-1.1-.23c-.29 0-.57.05-.84.13.23.23.36.53.36.86C8.22 5.45 7.67 6 7 6zM8.7 9.17c1.49 0 2.69-1.2 2.69-2.7 0-.32-.06-.63-.16-.92L7.78 9c.29.11.6.17.92.17zM7.3 8.77l3.7-3.7 1.01-1.01 1.79-1.79L15.29.78 14.52 0l-1.76 1.76-1.51 1.51-1 1L6.5 8.02 5.49 9.03l-1.74 1.74-1.65 1.65.77.78 1.95-1.95 1.46-1.46L7.3 8.77z"}})])])
          )
        }
      }
    